import React from 'react';
import { Chart } from 'react-google-charts';
import { Col } from 'react-bootstrap';
import getCurLang from '../../../businessLogic/getCurLang.js';
export default class PieCharts extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            options: {
                pieHole: 0.8,
                is3D: false,
                colors: ['#ccc', '#f26e5d'],
                legend: { position: 'none' },
                backgroundColor: 'transparent',
                tooltip: { trigger: 'none'},
                animation:{
                    startup: true,
                    duration: 500,
                    easing: 'linear'
                }
            }
        }
    }

    selectOption(title, name) {
        this.props.selectOption(title, name)
    }

    render() {
        const { title, commmentOne, tooltip,  commmentTwo, valueOne, valueTwo, percentOne, percentTwo, data, id, name, isSelected } = this.props;
        const { options } = this.state;
        return (
            <Col sm={12} className={isSelected === true ? 'is-active': 'is-not-active'}>
                <div className="pie-chart-container" onClick={() => this.selectOption(title, name)}>
                    <div className="chart-info">
                        <div className="title"> {title} <div className="tooltip-title"><img src="./info.png"/><span className="tooltiptext">{tooltip}</span></div> </div>
                        {(getCurLang()==='ar')?
                            <div className="comment one">({percentOne}%) {commmentOne} {valueOne}</div>:
                            <div className="comment one">{commmentOne} {valueOne} ({percentOne}%)</div>
                        }
                        {(getCurLang()==='ar')?
                            <div className="comment two">({percentTwo}%) {commmentTwo} {valueTwo}</div>:
                            <div className="comment two">{commmentTwo} {valueTwo} ({percentTwo}%)</div>
                        }
                        <div className="parallelogram"><p> Total: {(valueOne + valueTwo).toFixed(2)} ({percentOne + percentTwo}%)</p></div>
                    </div>
                    <Chart
                        chartType="PieChart"
                        data={data}
                        options={options}
                        graph_id={id}
                        width="150px"
                        height="150px"
                        position="absolute"
                        legend_toggle
                    />
                    <p className="left-percent">{Math.round(percentOne)}%</p>
                    <p className="right-percent">{Math.round(percentTwo)}%</p>
                </div>
            </Col>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/settings/components/PieChart.js